import {Button} from '@wandb/weave/components';
import _ from 'lodash';
import React from 'react';

import {type GraphErrors, type GraphZoom} from './graphRenderProps';

export const errorMessageDetails = {
  empty_chart: 'Select a metric to visualize in this line chart.',
  no_lines: 'No lines to visualize',
  no_lines_for_metric: `Select runs that logged this metric to visualize data in this line chart.`,
  no_data: `There's no data for the selected runs. Try a different X axis setting.`,
};

export const getErrorMessage = (
  errors: GraphErrors,
  isDelayed: boolean, // indicates the query hasn't run yet
  lines: {data: {length: number}; nanPoints?: {length: number}}[],
  zoom: Pick<GraphZoom, 'isActive' | 'onReset' | 'onZoom'>
) => {
  if (isDelayed) {
    return ['', null];
  }
  if ((errors.metricKeys?.length ?? 0) === 0 && !errors.hasExpressions) {
    return [
      errorMessageDetails.empty_chart,
      'Select a metric to visualize in this line chart.',
    ];
  } else if (_.isEmpty(lines)) {
    if (errors.metricKeys != null && errors.metricKeys.length > 0) {
      return [
        errorMessageDetails.no_lines_for_metric,
        <>
          Select runs that logged {errors.metricKeys[0]} <br />
          to visualize data in this line chart.
        </>,
      ];
    } else {
      return [errorMessageDetails.no_lines, <>No lines to visualize</>];
    }
  } else if (lines.every(l => _.isEmpty(l.data) && _.isEmpty(l.nanPoints))) {
    return [
      errorMessageDetails.no_data,
      <>
        <div>There's no data for the selected runs.</div>
        <div>
          {zoom.isActive ? 'Zoom out or t' : 'T'}ry a different X axis setting.
        </div>
        <div className="mb-4">Current X axis: {errors.savedXKey} </div>
        {zoom.isActive && (
          <div>
            <Button
              onClick={() => {
                if (zoom.onReset) {
                  zoom.onReset();
                  return;
                }
                zoom.onZoom({
                  intent: {
                    shouldZoomX: false,
                    shouldZoomY: false,
                  },
                });
              }}>
              Zoom out
            </Button>
          </div>
        )}
      </>,
    ];
  }

  return ['', null];
};
